import styled from "styled-components";
import React from "react";
import Empty from "../Assets/Empty.png";
import Button from "./Button";

const Container = styled.div`
	display: flex;
	width: 100%;
	height: 100%;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	background: #fff;
	border-radius: 10px;
	padding: 2rem;
`;

const Text = styled.span`
	font-size: 1.2rem;
	font-weight: 600;
	font-family: inherit;
	margin: 2rem 0 0 0;
	color: rgba(0, 0, 0, 0.8);
`;

const Img = styled.img``;

const EmptyState = (props) => {

	const { message, retryButtonText } = props;

	return (
		<Container>
			<Img src={Empty} alt={"Empty state"} />
			<Text>{message || "No data available"}</Text>
			{props.retry ? (
				<Button onClick={() => props.retry()} margin="2rem 0 0 0" width="10rem" active>
					{ retryButtonText || "Retry"} 
				</Button>
			) : (
				""
			)}
		</Container>
	);
};

export default EmptyState;
